import { render } from "./GenerateTab.vue?vue&type=template&id=72362564"
import script from "./GenerateTab.vue?vue&type=script&lang=js"
export * from "./GenerateTab.vue?vue&type=script&lang=js"

import "./GenerateTab.vue?vue&type=style&index=0&id=72362564&lang=scss"
script.render = render

export default script